import { useCopies } from "shared/hooks/useCopies";
import { CellEllipsisProps } from "../table.types";
import classNames from "classnames";

export default function CellEllipsis(props: CellEllipsisProps) {
  const copies = useCopies();
  return (
    <div className={classNames("td_ellipsis", props.className)} title={props.title || props.value} style={props.style}>
      {props.displayEmptyCell ? props.value ?? copies.get("empty.cell") : props.value || copies.get("empty.cell")}
    </div>
  );
}

export function CellEllipsisDisplayZero(props: CellEllipsisProps) {
  return <CellEllipsis {...props} displayEmptyCell />;
}
